import BaseService from "./BaseService"
import BaseFilter from './BaseFilter';

export class NationalHolidayService extends BaseService{
	constructor() {
		super('/NationalHoliday');
	}


	public deleteList(list: number[]) {
		return this.deleteListWithResourceName(list, 'delete-list')
	}

	public getAllByFilter(filter: NationalHolidayFilter) {
		return super.getAllByFilterBase(filter);
	}
}

export class NationalHolidayFilter extends BaseFilter{
	constructor(countryAlpha?: string | null) {
		super();
	
		this._countryAlpha = countryAlpha;
		
	}

	private _countryAlpha?: string | null;
	

	public getAllParams(): {} {
		let data = Object.assign({},
			(this._countryAlpha != null ? { CountryAlpha: this._countryAlpha } : {})
	
		);

		return data;
	};
}